import { TaskVehiclePair } from '@bringg/dashboard-sdk/dist/Run/Service/runs.service';
import { Task } from '@bringg/types';
import { TFunction } from 'i18next';

export interface VehicleRealtimeAsyncEvent {
	vehicleId: number;
	trailerId: number;
	isPowerUnit: boolean;
}

export const vehicleTranslation = (t: TFunction) => {
	return {
		labelTextSearchInput: t('RUN_VEHICLE_ASSIGNMENT.MATCH_VEHICLE'),
		name: t('RUN_VEHICLE_ASSIGNMENT.VEHICLE_NAME'),
		type: t('RUN_VEHICLE_ASSIGNMENT.VEHICLE_TYPE'),
		skills: t('RUN_VEHICLE_ASSIGNMENT.VEHICLE_SKILLS'),
		capacity: t('RUN_VEHICLE_ASSIGNMENT.VEHICLE_CAPACITY')
	};
};
export const trailerTranslation = (t: TFunction) => {
	return {
		labelTextSearchInput: t('RUN_TRAILER_ASSIGNMENT.MATCH_TRAILER'),
		name: t('RUN_TRAILER_ASSIGNMENT.TRAILER_NAME'),
		type: t('RUN_TRAILER_ASSIGNMENT.TRAILER_TYPE'),
		skills: t('RUN_TRAILER_ASSIGNMENT.TRAILER_SKILLS'),
		capacity: t('RUN_TRAILER_ASSIGNMENT.TRAILER_CAPACITY')
	};
};

export const initializeButtonsLoading = {
	ok: false,
	unassignTrailer: false,
	unassignVehicles: false
};

export interface ButtonsLoading {
	ok: boolean;
	unassignTrailer: boolean;
	unassignVehicles: boolean;
}

export interface VehicleModalData {
	vehicleId: number | null;
	trailerId: number | null;
	userId: number | null;
	runId: number;
	tasks: Task[];
	teamIds: number[];
	weight: { maxValue: number; value: number } | undefined;
}

export interface VehicleUpdateProps {
	runId: number;
	vehicleId: number;
	tasksIds: TaskVehiclePair[];
}
export interface ModalParams {
	data: VehicleModalData;
	handleListUpdate?: ({ runId, vehicleId, tasksIds }: VehicleUpdateProps) => void;
	hideUnassignVehicleButton?: boolean;
	doNotNotifyServerOnAssign?: boolean;
}
